import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'warrantyEndDate',
    standalone: false
})
export class WarrantyEndDatePipe implements PipeTransform {
  transform(purchaseDate: string | Date | undefined, warrantyMonths: number | undefined): Date | null {
    if (!purchaseDate || warrantyMonths === undefined) {
      return null;
    }

    const startDate = new Date(purchaseDate);
    if (isNaN(startDate.getTime())) {
      return null;
    }

    const endDate = new Date(startDate);
    endDate.setMonth(endDate.getMonth() + warrantyMonths);

    return endDate;
  }
}
